<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1002 Body Part -->
							<template>
								<el-container>
									<div class="SID1002__MailDestSelection">
										<!-- Breadcrumb section -->
										<section>
											<el-breadcrumb separator-class="el-icon-arrow-right" class="mailDestlink">
												<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
												<el-breadcrumb-item :to="{ path: '' }">メール送信先選択</el-breadcrumb-item>
											</el-breadcrumb>
										</section>
										<!-- Form section -->
										<section class="formSection">
											<span class="searchForm">検索</span>	
											<el-form ref="form" :model="form" label-width="auto" class="mailDestForm">
												<el-form-item  class="formLabelAlignment" label="記事セットアップ日 " prop="date">
													<span  class="themeAlertClass">{{ themeSpan }}</span>
													<v-date-picker v-model="date" :masks="{ title: 'YYYY年MMM' }" :popover="{  visibility: 'click' }" :input-props='{readonly : true}' locale="ja" @input="resetFunction"/>
												</el-form-item>
												<el-form-item class="formLabelAlignment" label="媒体 ">
													<el-select v-model="form.mediavalue" @change="mediaChange($event)" class="mailSelectDestOpn" placeholder="">
														<el-option
														v-for="(item,index) in serviceLinkageDropdown"
														:key="index"
														:label="item.label"
														:value="item.value">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item class="formLabelAlignment" label="テーマ ">
													<el-select v-model="form.themevalue" id="selected_id" @change="handleThemeChange($event)" placeholder="">
														<el-option
														v-for="(item,index) in GetthemeDropdownData1002"
														:key="index"
														:label="item.label"
														:value="index">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item class="formLabelAlignment" label="アドレス ">
													<el-select v-model="form.addressvalue" @change="mailChange($event)" placeholder="">
														<el-option
														v-for="(item,index) in GetmailDropdownData1002"
														:key="index"
														:label="item.mail_address"
														:value="item.mail_address">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item class="buttonClickFun">
													<el-button v-on:click="TableVisible = true" type="primary" @click="ShowTableData()" plain>検索</el-button>
												</el-form-item>
											</el-form>
										</section>
										<!-- Table section -->
										<section>
											<el-row class="ButtonSubmitTop" v-if="TableVisible">
												<!-- 2022/01/20  #11866  START -->
												<!-- <el-button @click="SendMail" type="primary" plain>送信</el-button> -->
												<el-button v-loading.fullscreen.lock="fullscreenLoading" @click="SendMail" type="primary" plain>送信</el-button>
												<!-- 2022/01/20  #11866  END -->
											</el-row>
											<div v-if="TableVisible">
												<el-table ref="multipleTable" :data="getTableResult1002" border  style="width: 100%" @selection-change="handleSelectionChange"  v-loading="loading">
														<el-table-column type="selection" width="60"> </el-table-column>
														<el-table-column property="data_section" label="媒体" min-width="60"> </el-table-column>
														<el-table-column property="mail_address" label="メールアドレス" min-width="150"> </el-table-column>
														<el-table-column property="theme_name" label="テーマ名" min-width="350"> </el-table-column>
														<el-table-column  property="template_file_name" label="テンプレート" min-width="350"> </el-table-column>
														<el-table-column v-if="content" label="送信結果"  property="send_result" min-width="90"></el-table-column>
												</el-table>
											</div>
											<el-row class="ButtonSubmitBottom" v-if="TableVisible">
												<el-button @click="SendMail()" type="primary" plain>送信</el-button>
											</el-row>
										</section>
									</div>
								</el-container>
							</template>
              <!--SID1002 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import json from '../../components/config.json'
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
const newArr = {};
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		return {
			loading: false,
			userId:'',
			contractId:'',
			userAuthority:'',
			select_option_theme_id:'',
			select_option_theme_label: '',
			select_option_data_kbn: '',
			select_media_value:'',
			select_mail_address_value:'',
			fullscreenLoading: false, // 2022/01/20  #11866
			form: {
				themevalue: ' ',
				mediavalue: ' ',
				addressvalue: ' ',
			},
			dummy: '',
			TableVisible: true,
			value1: true,
			value2: true,
			value3: true,
			value4: true,

			date: new Date(),			
			
			themeoptions: [{
				value: 'すべて',
				label: 'すべて'
			}, {
				value: '自社関連',
				label: '自社関連'
			}, {
				value: 'テーマグループG',
				label: 'テーマグループG'
			}, {
				value: 'トピックス',
				label: 'トピックス'
			}],
			
			mediaoptions: [{
				value: '新聞',
				label: '新聞'
			},{
				value: '雑誌/WEB',
				label: '雑誌/WEB'
			},{
				value: 'WEB',
				label: 'WEB'
			}],
			
			addressoptions: [{
				value: 'xxx＠exmaple.com',
				label: 'xxx＠exmaple.com'
			}],
			
			multipleSelection: [],
			rowData:[],
			content: false,
			serviceLinkageDropdown:[
				{
					value: '',
					label: ''
				}
			],
			user_group_id:'',
			themeSpan: '',
			resetDateValue: new Date()
        };
	},
    
    computed: {
		...mapGetters("situation1002", ["getTableResult1002",
			"getdateoptions",
			"getdatevalue",
			"getthemeoptions",
			"getthemevalue",
			"getmediaoptions",
			"getmediavalue",
			"getaddressoptions",
			"getaddressvalue",
			"GetmailDropdownData1002",
			"GetthemeDropdownData1002"]),
		...mapGetters("situation0001", ["getUserId",
			"getContractId",
			"getNews_Article_Flag",
			"getMagazine_Article_Flag",
			"getWeb_News_Article_Flag",
			// 2022/01/29 #11866 START
			"getMailSendMaxCount",
			// 2022/01/29 #11866 END
			"getUserAuthority",
			"getUserGroupId"])
	},
    methods: {
		handleSelectionChange(val){
			this.$LogButtonEvent("1002","Checkbox");
			this.$LogMethodIN("1002","handleSelectionChange");
			newArr.value=  val;
			this.$LogMethodOut("1002","handleSelectionChange");
		},
		onSubmit() {}, 
		handleThemeChange($event){
			this.$LogButtonEvent("1002","SelectTheme");
			this.$LogMethodIN("1002","handleThemeChange");
			
			//Given Array index as model value since the id has duplicates
			if(this.GetthemeDropdownData1002.length > 0)
			{
				this.select_option_theme_id = this.GetthemeDropdownData1002[$event]["value"];
				this.select_option_theme_label = this.GetthemeDropdownData1002[$event]["label"];
				this.select_option_data_kbn = this.GetthemeDropdownData1002[$event]["data_kbn"];

			}
			this.$LogMethodOut("1002","handleThemeChange");
		},
		
		mediaChange($event){
			this.$LogButtonEvent("1002","SelectMedia");
			this.$LogMethodIN("1002","mediaChange");
			this.select_media_value = $event;
			this.$LogMethodOut("1002","mediaChange");
		},

		mailChange($event){
			this.$LogButtonEvent("1002","SelectMail");
			this.$LogMethodIN("1002","mailChange");
			this.select_mail_address_value = $event;
			this.$LogMethodOut("1002","mailChange");
		},
		// Show table data while clicking Search Button
		ShowTableData(){
			this.$LogButtonEvent("1002","Search");
			this.$LogMethodIN("1002","ShowTableData");
			this.text ="";
			this.themeSpan = '';
			var theme_id = this.select_option_theme_id;
			var data_kbn = this.select_option_data_kbn;
			var mail_value = this.select_mail_address_value;
			var media_value = this.select_media_value;
			
			var searchDetails = {};
			if(media_value != '')//For the media
			{
				var dataSection = media_value === "1" ? 1 : media_value == "2" ? 2 : media_value === "5" ? 5 : 0;
				searchDetails.data_section = dataSection;
			}

			if(theme_id != '')//For the theme_topics_theme_group
			{
				if(data_kbn == 1)
				{
					searchDetails.theme_id = theme_id;
				}
				else if(data_kbn == 2)
				{
					searchDetails.theme_group_id = theme_id;
				}
				else if(data_kbn == 3)
				{
					searchDetails.topics_id = theme_id;
				}
				else
				{
					searchDetails.theme_flag = 0;
				}
			}
			else
			{
				searchDetails.theme_flag = 0;
			}
			if(mail_value != '')//For the mail address
			{
				searchDetails.address = mail_value;
			}
			

			//For the user authority
			searchDetails.user_authority = this.userAuthority;
			this.loading=true;
			this.$store.dispatch('communication1002/getTableData1002',searchDetails).then(()=>{
				this.loading=false;
			});
			this.$LogMethodOut("1002","ShowTableData");
		},      
		SendMail() {
		// 2022/01/20  #11866  START
		if (this.fullscreenLoading) {
			return
		}
		this.fullscreenLoading = true
		// 2022/01/20  #11866  END

		this.$LogButtonEvent("1002","Send");
		this.$LogMethodIN("1002","SendMail");
		if(this.$refs.multipleTable.selection.length > 0)
		{
			if(this.date != '' && this.date != null)
			{
				// 2022/10/18  #13762  START
				var lock = false;
				// 2022/10/18  #13762  END
				this.$confirm(json["1002_mailsend_confirm_message"], json["1002_mailsend_confirm_message_title"], {
				showCancelButton: true,		
				confirmButtonText: 'OK',
				cancelButtonText: 'キャンセル',
				beforeClose: (action, instance, done) => {
					// 2022/10/18  #13762  START
					if(lock){
						return
					}
					lock = true;
					// 2022/10/18  #13762  END
					this.$LogMethodIN("1002","Send Confirm OK");
					if (action === 'confirm') {

						this.themeSpan = '';
						this.content = true;
						var arrayLength = this.$refs.multipleTable.selection.length;
						// 2023/01/22  #17177  START
						this.$LogMethodIN("1002","Send Mail Count：" + arrayLength);
						// 2023/01/22  #17177  END

						// 2022/01/14  #11866  START
						/*
						var SendThemeArray = [];
						for(var i=0;i<arrayLength;i++){
							var send_data_section = newArr['value'][i].media_name == 101 ? 1 : newArr['value'][i].media_name == 5 ? 5 : 2;
							var  send_mail_address_id= newArr['value'][i].mail_address_id;
							var  send_mail_address= newArr['value'][i].mail_address;
							var  send_theme_id= (newArr['value'][i].theme_id).toString();
							var  send_theme_name = newArr['value'][i].theme_name;
							var  send_template_file_id= newArr['value'][i].template_file_id;
							var  send_template_file_name= newArr['value'][i].template_file_name;
							var  send_data_kbn= newArr['value'][i].data_kbn;

						SendThemeArray=[...SendThemeArray,{data_section: send_data_section, mail_address_id: send_mail_address_id, mail_address: send_mail_address,theme_id:send_theme_id,theme_name:send_theme_name,template_file_id:send_template_file_id, template_file_name:send_template_file_name, data_kbn: send_data_kbn } ]    
						}
						var dateFormatCheck=this.date;
						var splitDataFormat = new Date(dateFormatCheck),
						splitmonthFormat = ("0" + (splitDataFormat.getMonth() + 1)).slice(-2),
						splitdayFormat = ("0" + splitDataFormat.getDate()).slice(-2);
						var newDateFormat = [splitDataFormat.getFullYear(), splitmonthFormat, splitdayFormat].join("-");
				
						var themedet={
							sendmail_info:SendThemeArray,
							sendmail_allinfo:this.getTableResult1002,
							setup_datetime:newDateFormat
						};
						this.$store.dispatch('communication1002/SendEmail',themedet).then(() => {
							this.content = true;
						});        			
						*/
						var dateFormatCheck=this.date;
						var splitDataFormat = new Date(dateFormatCheck),
							splitmonthFormat = ("0" + (splitDataFormat.getMonth() + 1)).slice(-2),
							splitdayFormat = ("0" + splitDataFormat.getDate()).slice(-2);
						var newDateFormat = [splitDataFormat.getFullYear(), splitmonthFormat, splitdayFormat].join("-");

						// 2023/01/20  #14030  START
						//var datas = this.getMailSendMaxCount === undefined ? 50 : this.getMailSendMaxCount;
						this.getMailSendMaxCount = localStorage.getItem('MailSendMaxCount')
						var datas = this.getMailSendMaxCount === undefined ? 10 : this.getMailSendMaxCount;
						// 2023/01/20  #14030  END

						var SendThemeArray = [];
						var requestCounts = Math.ceil(arrayLength/datas)
						var requestIndex = 0;
						for(var i=0; i<arrayLength; i++){
							var send_data_section = newArr['value'][i].media_name == 101 ? 1 : newArr['value'][i].media_name == 5 ? 5 : 2;
							var send_mail_address_id= newArr['value'][i].mail_address_id;
							var send_mail_address= newArr['value'][i].mail_address;
							var send_theme_id= (newArr['value'][i].theme_id).toString();
							var send_theme_name = newArr['value'][i].theme_name;
							var send_template_file_id= newArr['value'][i].template_file_id;
							var send_template_file_name= newArr['value'][i].template_file_name;
							var send_data_kbn= newArr['value'][i].data_kbn;

							SendThemeArray=[...SendThemeArray,{data_section: send_data_section, mail_address_id: send_mail_address_id, mail_address: send_mail_address,theme_id:send_theme_id,theme_name:send_theme_name,template_file_id:send_template_file_id, template_file_name:send_template_file_name, data_kbn: send_data_kbn } ]
							if (((i+1) % datas == 0) || (i == arrayLength - 1)) {
							var themedet={
								sendmail_info:SendThemeArray,
								sendmail_allinfo:this.getTableResult1002,
								setup_datetime:newDateFormat
							};
							this.$store.dispatch('communication1002/SendEmail',themedet).then(() => {
								this.content = true;
								requestIndex++;
								if (requestCounts == requestIndex) {
								this.fullscreenLoading = false;
								}
							});
							SendThemeArray = [];
							}
						}
						// 2022/01/14  #11866  END

						done();
					} else {
						// 2022/01/20  #11866  START
						this.fullscreenLoading = false;
						// 2022/01/20  #11866  END

						done();
					}
				}
				})

			}
			else
			{
				// 2022/01/20  #11866  START
				this.fullscreenLoading = false;
				// 2022/01/20  #11866  END

				this.themeSpan="日付を入力してください。";
			}

		}
		else
		{
			// 2022/01/20  #11866  START
			this.fullscreenLoading = false;
			// 2022/01/20  #11866  END

			this.$alert(json["1002_checkbox_not_check_message"], json["1002_checkbox_not_check_message_title"], {
				confirmButtonText: 'OK'
			});  
		}
		this.$LogMethodOut("1002","SendMail");
	},
	/*** Change by AJ for backlog Id: 1576 */
	resetFunction(){
		this.themeSpan = '';

		//Code for set the selected date when double click the calender
		if(this.date != null)
		{
			this.resetDateValue = this.date;
		}
		else
		{
			this.date = new Date(this.resetDateValue);
		}
	},
	/*** Change by AJ for backlog Id: 1576 */
},
mounted() {
	//For the media dropdown
	var newsSession=this.getNews_Article_Flag;
	var magazineSession=this.getMagazine_Article_Flag;
	var webSession=this.getWeb_News_Article_Flag;
    
    if(newsSession == true){
      var innerLoopServicenews = {};
      innerLoopServicenews.label="新聞";
      innerLoopServicenews.value="1";
      this.serviceLinkageDropdown.push(innerLoopServicenews);
      
    }
	if(magazineSession == true){
      var innerLoopServiceMagazine = {};
      innerLoopServiceMagazine.label="雑誌/WEB";
      innerLoopServiceMagazine.value="5";
      this.serviceLinkageDropdown.push(innerLoopServiceMagazine);
      
    }
	if(webSession == true){
      var innerLoopServiceWeb = {};
      innerLoopServiceWeb.label="WEB";
      innerLoopServiceWeb.value="2";
      this.serviceLinkageDropdown.push(innerLoopServiceWeb);
      
    } 
	//get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
	this.contractId = this.getContractId;
	//get the user authority value from session
	this.userAuthority = this.getUserAuthority;

	this.user_group_id = this.getUserGroupId
    var parameters = {
		contract_id : this.contractId,
		user_authority: this.userAuthority,
		user_id: this.userId,
		user_group_id: this.user_group_id
    };		
	this.$store.dispatch('communication1002/getMailDropdownData1002',parameters);
	
		//For the date
		var searchDetails = {};
		searchDetails.theme_flag = 0;
		
		//For the user authority
		searchDetails.user_authority = this.userAuthority
	this.$store.dispatch('communication1002/getThemeDropdownData1002',parameters).then(()=>{//For set the topic
		if(this.$route.params.fromTopPage == 2){
			// Function Call from the SDI1020 screen 
			//For set the medium
			if(this.$route.params.medium){
				this.form.mediavalue=this.$route.params.medium;
				this.select_media_value=this.$route.params.medium == "新聞" ? "1" :this.$route.params.medium == "雑誌/WEB"? "5" : "2";
			}else{
				this.form.mediavalue=""
			}
			searchDetails.data_section = this.select_media_value;
			for(var i=0;i<this.GetthemeDropdownData1002.length;i++){
				if(this.GetthemeDropdownData1002[i].data_kbn == 3 && this.GetthemeDropdownData1002[i].value == this.$route.params.topic ){
					this.form.themevalue=i;
					this.select_option_theme_id=this.GetthemeDropdownData1002[i].value;
					break;
				}
			}
			searchDetails.topics_id = this.select_option_theme_id;
			// 2021/09/29  #11862  START
			this.select_option_data_kbn = 3;
			// 2021/09/29  #11862  END
		this.loading=true;
		this.$store.dispatch('communication1002/getTableData1002',searchDetails).then(()=>{
			this.loading=false;
		});
		
		}else if(this.$route.params.fromTopPage == 1){			
			this.loading=true;
			this.$store.dispatch('communication1002/getTableData1002',searchDetails).then(()=>{
				this.loading=false;
			});
		}else{
			this.loading=true;
			this.$store.dispatch('communication1002/getTableData1002',searchDetails).then(()=>{
				this.loading=false;
			});
			}
	});
	
	
	
	

},
beforeCreate(){
	//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
created(){
	//For the screen Title
     document.title = "メール送信先選択画面";
	
}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1002.css";
</style>